const TeamWork = () => {
  return (
    <div className="flex flex-col items-center bg-black text-white py-16">
      <h1 className="text-4xl font-bold mb-2">VERIFIED VENDORS</h1>
      <p className="text-base font-light mb-8">GREAT PARTNERSHIPS BUILD GREAT THINGS</p>
      <div className="flex bg-[#080808] rounded-lg w-[248px] h-[140px] justify-center items-center">
        <img src="/static/images/partners/n.svg" alt="cregen" className="w-5 h-5" />
        <img src="/static/images/partners/g.svg" alt="cregen" className="w-5 h-5" />
        <img src="/static/images/partners/e.svg" alt="cregen" className="w-5 h-14 mt-3" />
        <img src="/static/images/partners/r.svg" alt="cregen" className="w-5 h-5" />
        <img src="/static/images/partners/c.svg" alt="cregen" className="w-5 h-5 " />
      </div>
    </div>
  );
}

export default TeamWork;
